import { CSSProperties } from 'react';

const card: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};

export { card };
